// Action Types

/**
 * createTypes is a function to create CONSTANT action types instead of regular strings to prevent typo mistakes.
 * @param  {array} strings
 */
function createTypes(strings, ...types) {
  types = [...strings, types];
  types = types.join("\n");
  types = types.split("\n");
  const TYPES = {};
  for (let type of types) {
    if (type === "") {
      continue;
    }
    TYPES[type] = type;
  }
  return TYPES;
}

/**
 * createOurSteps is a function to create the four types for given action.
 * @method
 * @param {string} PREFEX - The PREFEX for each generated type.
 */
function createSteps(PREFEX) {
  const OUR_STEPS = ["loading", "success", "fail"];

  const OUR_STEP_CREATED = [PREFEX.toUpperCase()];

  OUR_STEPS.forEach((STEP) =>
    OUR_STEP_CREATED.push(`${PREFEX}_${STEP}`.toUpperCase())
  );

  return OUR_STEP_CREATED.join("\n");
}

const types = [
  "GET_CONTESTS",
];

export default createTypes`
RESET_PROJECTS_ACTIONS

${types.map(createSteps).join("\n")}
`;

export const CLEAR_ADD_PROJECT_SUCCESS = "CLEAR_ADD_PROJECT_SUCCESS";
export const CLEAR_CURRENT_PROJECT = "CLEAR_CURRENT_PROJECT";
export const CLEAR_DELETE_PROJECT_SUCCESS = "CLEAR_DELETE_PROJECT_SUCCESS";
export const CLEAR_ADD_PROJECT_BID_SUCCESS = "CLEAR_ADD_PROJECT_BID_SUCCESS";
export const CLEAR_SELECT_PROJECT_BID_SUCCESS = "CLEAR_SELECT_PROJECT_BID_SUCCESS";
export const CLEAR_CLOSE_PROJECT_SUCCESS = "CLEAR_CLOSE_PROJECT_SUCCESS";
export const CLEAR_RATE_PROJECT_SUCCESS = "CLEAR_RATE_PROJECT_SUCCESS";
export const CLEAR_REQUEST_CLOSE_PROJECT_SUCCESS = "CLEAR_REQUEST_CLOSE_PROJECT_SUCCESS";
